import React from 'react';
import {useHeader} from '../../../../_metronic/layout';
import {useIntl} from 'react-intl';
import SubheaderBar from '../../_common/components/SubheaderBar';
import PriceCatalogFilters from '../components/PriceCatalogFilters';
import PriceCatalogTable from '../components/PriceCatalogTable';
import {PriceCatalogProvider} from '../contexts/PriceCatalogContext';

const PriceCatalogPage = () => {
  const header = useHeader();
  const intl = useIntl();

  header.setTitle(
    intl.formatMessage({
      id: 'price-catalog-page-header',
      defaultMessage: 'Price catalog page',
    })
  );

  return (
    <PriceCatalogProvider>
      <SubheaderBar>
        <PriceCatalogFilters/>
      </SubheaderBar>
      <PriceCatalogTable/>
    </PriceCatalogProvider>
  );
};

export default PriceCatalogPage;